<template>
	<div id="about">
		<div>工具下载</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
			};
		},
		methods: {
			onClick(){
			}
		}
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/view/download/index.vue